module.exports = __webpack_public_path__ + "img/sleeve flounce opening.0eda8b99.png";